import { render, staticRenderFns } from "./instructorsComponent.vue?vue&type=template&id=4b71dc51&scoped=true&"
import script from "./instructorsComponent.vue?vue&type=script&lang=js&"
export * from "./instructorsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b71dc51",
  null
  
)

export default component.exports